/**
 * Customer-portal brand resolution.
 *
 * This app is served on BOTH customer.tradesmatepro.com and customer.smbmate.com
 * (see whitelabels.customer_portal_url), but the login/signup screens hardcoded
 * "TradeMate Pro" — so an SMBMate customer was shown the wrong company's name, and
 * TradesMatePro customers were shown a misspelling of ours.
 *
 * Hostname is the right signal here: these screens render BEFORE authentication, so
 * there is no company context to look a brand up from. Mirrors
 * contractor-app/src/utils/brandingUtils.js resolveBrandFromHostname().
 */

// Vocabulary for the ONE noun that does not survive white-labelling in this app.
//
// A customer on TradesMatePro is hiring a contractor. A customer on SMBMate might be
// hiring a bookkeeper, a tutor or a salon — "Select Your Contractor" is wrong for all
// three. Everything else the portal says ("job", "quote", "invoice", "request") is
// already neutral and is deliberately left alone.
//
// This is presentation only. The marketplace MODEL is unchanged: customers post
// requests, businesses bid, and only the accepted one pays a fee (CLAUDE.md section 7).
// Nothing here touches a table, a column or the fee logic.
const TRADE_TERMS = {
  provider: 'Contractor',
  providers: 'Contractors',
  providerLower: 'contractor'
};

const BUSINESS_TERMS = {
  provider: 'Provider',
  providers: 'Providers',
  providerLower: 'provider'
};

export const BRANDS = {
  tradesmate: {
    name: 'TradesMatePro',
    supportEmail: 'jerry@tradesmatepro.com',
    websiteUrl: 'https://www.tradesmatepro.com',
    terms: TRADE_TERMS,
  },
  smbmate: {
    name: 'SMBMate',
    supportEmail: 'jerry@tradesmatepro.com',
    websiteUrl: 'https://www.smbmate.com',
    terms: BUSINESS_TERMS,
  },
};

/** Resolve the brand code from the current hostname. Defaults to tradesmate. */
export function resolveBrandCode() {
  if (typeof window === 'undefined') return 'tradesmate';
  return window.location.hostname.toLowerCase().includes('smbmate') ? 'smbmate' : 'tradesmate';
}

/** The active brand config for this hostname. */
export function getBrand() {
  return BRANDS[resolveBrandCode()] || BRANDS.tradesmate;
}

/** Convenience: the display name shown in headings. */
export function getBrandName() {
  return getBrand().name;
}

/**
 * Brand term lookup. Falls back to the trade wording rather than empty — a heading
 * rendering "Select Your undefined" is worse than one that is merely wrong for a brand.
 */
export function t(key) {
  const brand = getBrand();
  return (brand.terms || TRADE_TERMS)[key] || TRADE_TERMS[key] || '';
}
